import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import { Invitation } from '../../modals';
import { getLocalUserData, handleGraphqlError } from '../../../utils';
import { CREATE_INVITATION, LOADER_MUTATION } from '../../../graphql-client/mutations';


function InvitationContainer(props) {
  const { addToast } = useToasts();
  const { isOpen } = props;
  const [modal, setModal] = useState(isOpen);
  const { role } = getLocalUserData();
  const onClose = (isModalOpen) => {
    setModal(isModalOpen);
    props.onClose();
  };

  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });
  const [createInvitation] = useMutation(CREATE_INVITATION, {
    variables: {},
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
      props.onClose();
      onClose(false);
    },

    onCompleted(profileData) {
      loaderMutate({ variables: { show: false } });
      addToast(profileData.createInvitation.message, { appearance: 'success' });
      onClose(false);
      props.onClose();
    },

  });
  const submitCallBack = (data) => {
    loaderMutate({ variables: { show: true } });
    createInvitation({ variables: data });
  };


  return (
    <Invitation
      onClose={onClose}
      isOpen={modal}
      role={role}
      submitCallBack={submitCallBack}
    />
  );
}
InvitationContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InvitationContainer;
